/**
 * R. Venue API Layer
 * Configured to route through local Cloudflare Functions for custom auth logic.
 */

async function apiRequest(path, options = {}) {
  try {
    const res = await fetch(path, {
      credentials: 'include',
      headers: { 
        'Content-Type': 'application/json',
        ...options.headers 
      },
      ...options,
    });

    const body = await res.json().catch(() => ({}));
    
    if (!res.ok) {
      return { 
        status: 'error', 
        data: null, 
        error: body?.message || body?.error || `HTTP ${res.status}`, 
        httpStatus: res.status 
      };
    }

    // Standardize NCB response envelope
    if (body && typeof body === 'object' && !Array.isArray(body) && typeof body.status === 'string' && 'data' in body) {
      return body;
    }
    
    return { status: 'success', data: body };
  } catch (err) {
    return { status: 'error', data: null, error: err?.message || 'Network error' };
  }
}

/**
 * Custom Auth Endpoints (Cloudflare Functions)
 */
export async function authFetch(path, options = {}) {
  const cleanPath = path.startsWith('/') ? path : `/api/auth/${path}`;
  return apiRequest(cleanPath, options);
}

/**
 * Secure NCB Data Proxy
 */
export async function dataFetch(path, options = {}) {
  const cleanPath = path.startsWith('/') ? path : `/api/ncb/${path}`;
  return apiRequest(cleanPath, options);
}

/**
 * Public NCB Data Proxy
 */
export async function publicDataFetch(path, options = {}) {
  const cleanPath = path.startsWith('/') ? path : `/api/public/${path}`;
  return apiRequest(cleanPath, options);
}